import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap5';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import BaseModal from 'components/new_ui/Modal/Modal';
import { useContext as useUsersContext } from 'components/Users/Context';

export default function Modal({ show, onClose }) {
  const { dispatch: dispatchUsers, actions: actionsUsers } = useUsersContext();
  const [loading, setLoading] = useState(false);

  const refreshAffiliate = () => {
    setLoading(true);

    actionsUsers.load(
      dispatchUsers,
      () => {
        setLoading(false);
        onClose();
      },
    );
  };

  return (
    <BaseModal show={show}>
      <h3 className="mb-5">Request Sent Successfully!</h3>

      <p>
        Your request for access has been submitted. We&apos;ll process it shortly. Stay tuned!
      </p>

      <footer>
        <Button
          onClick={refreshAffiliate}
          disabled={loading}
        >
          {loading && <LoadingPlaceholder placement="inline" text=" " />}
          Got it
        </Button>
      </footer>
    </BaseModal>
  );
}

Modal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
